import apiUrl from '../../../constants'
import user_tracker from '../../../usertracker'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment'
import { BasicSelect,ModelSelect} from 'vue-search-select';
import download from 'downloadjs';

export default {
  name: 'AllocateHubToTouchPointForNetworkNew',
  components: {
    BasicSelect,
    ModelSelect,
    VueElementLoading,
    Multiselect,
    download
  },
  props: [],
  data() {
    return {
      hubzoneid: '',
      listHubZoneData: [],
      routetype: {},
      routetypelist: [{
        value: 0,
        text: 'Network'
      },{
        value: 4,
        text: 'Local-TP'
      }],
      sourceHubId: '',
      listSourceHubNameData: [],
      ConnectionID: [],
      listConnection: [],
      srcTouchPointName: {},
      TouchPointnameData: [],
      status: '',
      statusList: [{
				value: "1",
				text: "Selected"
			},
      {
				value: "0",
				text: "Not Selected"
			}],
      destHubZone: '',
      listHubZoneData: [],
      destHubId: '',
      listDestHubNameData: [],
      destCity: '',
      groupCity: '',
      cityList: [],
      destGroup: [],
      hubGroupList: [],
      HubArr: [],
      destData: [],
      connectionDestList: [],
      addmodalShow: false,
      checkAllHub:false,
      isLoadingSearch:false,
      totalHubRows: 0,
      totalmappedhubs: 0,
      connDestLoading:false,
      useremail:'',
      zoneLoading:'',
      sourceHubLoading:'',
      connectionLoading:'',
      srcTouchPointNameLoading:'',
      hubLoading:'',
      cityLoading:'',
      groupLoading:'',
      hideFilter:1,
      currentTab: 'inscan',
      tabs: [{
					key: 'inscan',
					value: 'Inscan',
          count: 0
				},
				{
					key: 'outscan',
					value: 'Outscan',
          count: 0
				}
			],
      clickedMB:false,
      modelArr:[],
      allHubData:[],
      checked:[],
      userData:[]
    }
  },
  computed: {
    currentTabComponent: function() {
      this.componentKey += 1
      return this.currentTab.toLowerCase()
    }
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes             = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext         = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail        = JSON.parse(plaintext);
    this.userData = userdetail;
    this.useremail        = userdetail[0].email;

    this.status = { value: "1", text: "Selected" };

    this.getHubZoneData();
    this.getCityList();
    this.getCitywiseGroups();
  },
  methods: {
    selectedTouchPoint() {
      this.resetHubSelection();

      if(this.srcTouchPointName.value && this.srcTouchPointName.type==='inscan'){
        this.currentTab = 'inscan',
        this.tabs = [{
  					key: 'inscan',
  					value: 'Inscan',
            count: 0
				}]
      }else if(this.srcTouchPointName.value && this.srcTouchPointName.type==='outscan'){
        this.currentTab = 'outscan',
        this.tabs = [{
  					key: 'outscan',
  					value: 'Outscan',
            count: 0
				}]
      }else{
        this.currentTab = 'inscan',
        this.tabs = [{
  					key: 'inscan',
  					value: 'Inscan',
            count: 0
  				},
  				{
  					key: 'outscan',
  					value: 'Outscan',
            count: 0
				}]
      }
      this.$validator.reset();
    },

    secondFunction(){
      if(this.clickedMB) this.resetHubForm();
    },

    labelWithGroup({ groupname, routemode, groupno }) {
      return `${groupname} - (${groupno})`;
    },

    customLabel ({ text, FullConnectionName }) {
      return `${text} – ${FullConnectionName}`;
    },

    getConnectionListByHubIDAndConnectionType() {

      if (Object.keys(this.sourceHubId).length <= 0 || Object.keys(this.routetype).length <= 0) { return false; }

      this.connectionLoading  = 'Loading Connection Name...'
      this.HubArr             = [];
      this.listConnection     = [];
      this.ConnectionID       = [];
      this.srcTouchPointName  = {};
      this.TouchPointnameData = [];
      this.resetHubSelection();

      this.input = {
        source: parseInt(this.sourceHubId.value),
        type: parseInt(this.routetype.value)
      }
      axios({
        'method': 'POST',
        'url': apiUrl.api_url_hubops + 'getroutemaster',
        'data': this.input,
        'headers': {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      })
      .then(result => {
        if (result.data.ResultCode == 100) {
          for (let i = 0; i < result.data.ResponseData.length; i++) {
            this.listConnection.push({
              value: result.data.ResponseData[i].ConnectionID,
              text: result.data.ResponseData[i].ConnectionName + ' ( TP' + result.data.ResponseData[i].Stoppoints.length + ' )',
              FullConnectionName: result.data.ResponseData[i].FullConnectionName,
              Stoppoints: result.data.ResponseData[i].Stoppoints
            })
          }
        } else {
          this.$alertify.error("No Connection Found!")
        }
        this.connectionLoading = '';
      }, error => {
        this.connectionLoading = '';
        this.$alertify.error("Connection API Error", "", "error");
        console.error(error);
      })
    },

    loadDisplayRoute() {

      this.srcTouchPointName     = {};
      this.TouchPointnameData    = [];
      this.srcTouchPointNameLoading = 'Loading Touch Point...'

      var connectionstopintsdata = this.listConnection.filter(obj => obj.value == this.ConnectionID.value);
      var stoppoints = connectionstopintsdata[0].Stoppoints;

      for (var i = 0; i < stoppoints.length; i++) {
        this.TouchPointnameData.push({
          value: stoppoints[i].StopPointHubId,
          text: stoppoints[i].StopPointName,
          type: (i===0) ? 'outscan' : (i===stoppoints.length-1) ? 'inscan' : 'both',
        })
      }
      this.srcTouchPointNameLoading = '';
      this.resetHubSelection();
    },

    getHubZoneData() {

      this.zoneLoading = 'Loading Zone...';
      this.resetHubSelection();
      this.listConnection     = [];
      this.ConnectionID       = [];
      this.TouchPointnameData = [];
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubzone/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            let listHubZoneData = result.data.ResponseData;
            for (let i = 0; i < listHubZoneData.length; i++) {
              this.listHubZoneData.push({
                value: listHubZoneData[i].hubzoneid,
                text: listHubZoneData[i].hubzonename
              })
            }
          }
          this.zoneLoading = '';
        }, error => {
          this.zoneLoading = '';
          console.error(error);
        })
    },

    getSourceHubNameList(zoneid,filter) {
      if(!zoneid) return false;

      if (filter==="parent") {
        this.sourceHubLoading = 'Loading Hub...'
        this.listSourceHubNameData = [];
        this.TouchPointnameData = [];
        this.listConnection     = [];
        this.ConnectionID       = [];
        this.resetHubSelection();
        this.sourceHubId= '';
      }else {
        this.hubLoading = 'Loading Hub...'
        this.listDestHubNameData = [];
        this.destHubId= '';
      }

      this.input = ({
        hubZoneId: zoneid
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            for (let i = 0; i < result.data.ResponseData.length; i++) {
              if (filter==='parent') {
                this.listSourceHubNameData.push({
                  value: result.data.ResponseData[i].HubID,
                  text: result.data.ResponseData[i].HubName + ' (' + result.data.ResponseData[i].HubID + ')',
                  hubcode: result.data.ResponseData[i].HubCode
                })
              }else{
                this.listDestHubNameData.push({
                  value: result.data.ResponseData[i].HubID,
                  text: result.data.ResponseData[i].HubName + ' (' + result.data.ResponseData[i].HubID + ')',
                  hubcode: result.data.ResponseData[i].HubCode
                })
              }
            }
          }
          this.sourceHubLoading = '';
          this.hubLoading = '';
        }, error => {
          this.sourceHubLoading = '';
          this.hubLoading = '';
          console.error(error)
        })
    },

    onSubmit: function() {
      this.$validator.validateAll()
        .then((result) => {
          if (!this.hubzoneid || Object.keys(this.routetype).length <= 0 || Object.keys(this.sourceHubId).length <= 0 || Object.keys(this.ConnectionID).length <= 0 || Object.keys(this.srcTouchPointName).length <= 0){
            document.getElementById("zone").innerHTML= (!this.hubzoneid) ? 'The Hub Zone field is required.':'';
            document.getElementById("route").innerHTML= (Object.keys(this.routetype).length <= 0) ? 'The Route Type field is required.':'';
            document.getElementById("source").innerHTML= (Object.keys(this.sourceHubId).length <= 0) ? 'The Source Hub Name field is required.':'';
            document.getElementById("conn").innerHTML= (Object.keys(this.ConnectionID).length <= 0) ? 'The Connection Name field is required.':'';
            document.getElementById("touch").innerHTML= (Object.keys(this.srcTouchPointName).length <= 0) ? 'The Touch Point field is required.':'';
            return false;
          }

          if (!result) {
            console.log('errors exist', this.errors);
            return false;
          } else {
            this.resetHubForm();
          }
        }).catch(() => {
          console.log('parent search errors exist', this.errors);
        });
    },

    resetForm() {
      this.hubzoneid= '',
      this.routetype= {},
      this.sourceHubId= '',
      this.listSourceHubNameData= [],
      this.ConnectionID= [],
      this.listConnection= [],
      this.srcTouchPointName= {},
      this.TouchPointnameData= [],
      this.status = { value: "1", text: "Selected" },
      this.destHubZone= '',
      this.destHubId= '',
      this.listDestHubNameData= [],
      this.destCity= '',
      this.groupCity= '',
      this.destGroup= [],
      this.HubArr= [],
      this.destData= [],
      this.connectionDestList= [],
      this.addmodalShow= false,
      this.checkAllHub= false,
      this.isLoadingSearch= false,
      this.totalHubRows= 0,
      this.totalmappedhubs= 0,
      this.zoneLoading= '',
      this.sourceHubLoading= '',
      this.connectionLoading= '',
      this.srcTouchPointNameLoading= '',
      this.hubLoading= '',
      this.cityLoading= '',
      this.groupLoading= '',
      this.connDestLoading= false,
      this.currentTab = 'inscan',
      this.tabs = [{
          key: 'inscan',
          value: 'Inscan',
          count: 0
        },
        {
          key: 'outscan',
          value: 'Outscan',
          count: 0
      }],
      this.allHubData= [],
      this.modelArr= [],
      this.checked= [],
      document.getElementById("zone").innerHTML='',
      document.getElementById("route").innerHTML='',
      document.getElementById("source").innerHTML='',
      document.getElementById("conn").innerHTML='',
      document.getElementById("touch").innerHTML='',
      this.$validator.reset();
    },

    closeStatusModal() {
      this.addmodalShow = false
    },

    //to get All City list
		getCityList() {
      this.cityLoading  = 'Loading City...'
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'allcity/get',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					var cityList = result.data.ResponseData
					for (let i = 0; i < cityList.length; i++) {
						this.cityList.push({
							value: cityList[i].cityid,
							text: cityList[i].cityname
						})
					}
          this.cityLoading  = '';
				}, error => {
          this.cityLoading  = '';
					console.error(error)
				})
		},

    getCitywiseGroups(city) {
      this.groupLoading  = 'Loading Group...'
      this.hubGroupList = [];

      this.input = ({})
      axios({
          method: 'GET',
          // legacy backup: getCityWiseGroups_v1
          // 'url': apiUrl.api_url_hubops + 'getCityWiseGroups_v1',
          'url': apiUrl.api_url_hubops + 'groups?routeMode=Surface&isActive=true',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubGroupList = result.data.ResponseData;
          }
          this.groupLoading  = '';
        }, error => {
          this.groupLoading  = '';
          console.error(error)
        })
    },

    getDestinationsByConnection() {
      if (Object.keys(this.ConnectionID).length <= 0 || Object.keys(this.srcTouchPointName).length <= 0 || Object.keys(this.sourceHubId).length <= 0) { return false; }

      this.connDestLoading    = true;
      this.destData           = [];
      this.HubArr             = [];
      this.connectionDestList = [];
      this.checkAllHub        = false;

      let groupids = (this.destGroup.length>0) ? this.destGroup.map(({ groupid }) => groupid).map(String) : [];

      this.input = ({
        connectionid: this.ConnectionID.value,
        status      : this.status.value ? this.status.value : 1,
        hubid       : this.destHubId.value,
        hubname     : this.destHubId.text,
        hubzoneid   : this.destHubZone,
        hubcityid   : this.destCity,
        groupcityid : this.groupCity,
        groupids    : groupids,
        createdBy   : this.useremail,
        touchPointID: this.srcTouchPointName.value,
      })

      let api = '';
      if(this.currentTab=='outscan'){
        this.input.stoppointid = this.sourceHubId.value;
        api = 'getDestinationsByConnectionForAllocateToTuchPointNew';
      }else{
        api = 'getDestinationsByConnection_ATTPInscanNew';
      }

      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + api,
          'data': this.input,
          headers: {
            'Authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            let j=0; let list=[]; let dlist=[];
            let hData = result.data.ResponseData;
            for (var i = 0; i < hData.length; i++) {
              if(j<2){
                list.push({
                  hubid:hData[i].HubID,
                  hubname:hData[i].HubName,
                  HubZoneName:hData[i].HubZoneName,
                  CityName:hData[i].CityName,
                  groupname:hData[i].groupname
                });
              }else{
                dlist.push(list);
                list=[]
                list.push({
                  hubid:hData[i].HubID,
                  hubname:hData[i].HubName,
                  HubZoneName:hData[i].HubZoneName,
                  CityName:hData[i].CityName,
                  groupname:hData[i].groupname
                });
                j=0;
              }
              j++;

              if(hData[i].isHubSelected==true){
                this.HubArr.indexOf(hData[i].HubID) === -1 ? this.HubArr.push(hData[i].HubID):'';
                this.checked[hData[i].HubID] = true;
              }

              this.destData.push({
                hubid:hData[i].HubID,
                hubname:hData[i].HubName
              });

              const allH = this.allHubData.some(el => el.hubid === hData[i].HubID);
              if (!allH) {
                this.allHubData.push({
                  hubid:hData[i].HubID,
                  hubname:hData[i].HubName
                });
              }
            }

            this.modelArr = (this.modelArr.length>0) ? this.modelArr : this.HubArr;
            dlist.push(list);
            this.connectionDestList = dlist;

            if(this.srcTouchPointName.type=='both'){
              this.tabs[0].count = this.currentTab=='inscan' ? result.data.TotalSelectedHubsForTHisConn : 0;
              this.tabs[1].count = this.currentTab=='outscan' ? result.data.TotalSelectedHubsForTHisConn : 0;
            }else{
              this.tabs[0].count = result.data.TotalSelectedHubsForTHisConn;
            }

            this.totalHubRows = result.data.TotalCount;
            if(this.HubArr.length === this.destData.length) this.checkAllHub = true;
          }else{
            this.totalHubRows=0;
            this.$alertify.error(result.data.ReturnMessage, "", "error");
          }
          this.connDestLoading=false;
        }, error => {
          this.connDestLoading=false;
          console.error(error)
        })
    },

    checkHub() {
      if(typeof InstallTrigger !== 'undefined' == true){ this.checkAllHub = !this.checkAllHub; }
      this.HubArr = [];

      let nArr = [...new Set(this.destData.map(a => a.hubid))];

      if (this.checkAllHub) {

        for (var i = 0; i < this.destData.length; i++) {
          this.checked[this.destData[i].hubid]=true;
        }

        this.HubArr   = nArr;
        let arr = [...this.modelArr, ...nArr];
        this.modelArr = [...new Set(arr)];
      }else{

        for (var i = 0; i < this.destData.length; i++) {
          this.checked[this.destData[i].hubid]=false;
        }

        this.modelArr = this.modelArr.filter(val => !nArr.includes(val));
      }
    },

     updateCheckDest(event){
       this.checked[event.target.id] = event.target.checked;

       if(event.target.checked==false){
        this.modelArr = this.modelArr.filter(el => el != event.target.id)

       }else{
        this.modelArr.indexOf(event.target.id) === -1 ? this.modelArr.push(parseInt(event.target.id)):'';
       }

       this.checkAllHub = (this.destData.length === this.modelArr.length) ? true : false;
     },

    onSubmitHubSearch: function(elem) {
     this.$validator.validateAll('hub').then((result) => {

       if (!this.hubzoneid || Object.keys(this.routetype).length <= 0 || Object.keys(this.sourceHubId).length <= 0 || Object.keys(this.ConnectionID).length <= 0 || Object.keys(this.srcTouchPointName).length <= 0 || Object.keys(this.status).length <= 0){
         document.getElementById("zone").innerHTML= (!this.hubzoneid) ? 'The Hub Zone field is required.':'';
         document.getElementById("route").innerHTML= (Object.keys(this.routetype).length <= 0) ? 'The Route Type field is required.':'';
         document.getElementById("source").innerHTML= (Object.keys(this.sourceHubId).length <= 0) ? 'The Source Hub Name field is required.':'';
         document.getElementById("conn").innerHTML= (Object.keys(this.ConnectionID).length <= 0) ? 'The Connection Name field is required.':'';
         document.getElementById("touch").innerHTML= (Object.keys(this.srcTouchPointName).length <= 0) ? 'The Touch Point field is required.':'';
         document.getElementById("status").innerHTML= (Object.keys(this.status).length <= 0) ? 'The Status field is required.':'';
         return false;
       }

       if (result) {
         this.getDestinationsByConnection()
       }else{
         console.log('errors exist');
         return false;
       }
     }).catch(() => {});
   },

    onSubmitHub: function(elem) {
     this.$validator.validateAll('hubsave').then((result) => {
       if (result) {
         if (Object.keys(this.ConnectionID).length <= 0 || Object.keys(this.srcTouchPointName).length <= 0 || Object.keys(this.sourceHubId).length <= 0 || this.modelArr.length <= 0) {
           this.$alertify.error('Destination selection or connection or touch point should not be empty!'); return false;
         }else{
           this.addmodalShow = true
         }
       }else{
         return false;
       }
     }).catch(() => {});
   },

    mapMultipleHubsToConnection() {
     this.connDestLoading = true;

     let nArr = this.allHubData.filter((elem) => this.modelArr.find((el) => elem.hubid == el));

     this.input = ({
      touchPointID: this.srcTouchPointName.value,
      hubIdAndHubName: nArr,
      createdBy: this.useremail,
     })

     let api = '';
     if(this.currentTab=='outscan'){
       this.input.connectionID  = this.ConnectionID.value;
       this.input.stoppointid   = this.sourceHubId.value;
       api = 'saveStopPointHubAllocationNew';
     }else{
       this.input.sourceHubId     = this.sourceHubId.value;
       this.input.sourceHubName   = this.sourceHubId.text,
       this.input.connectionId    = this.ConnectionID.value;
       this.input.connectionName  = this.ConnectionID.text;
       this.input.hubCode         = this.sourceHubId.hubcode;
       api = 'mapMultipleHubsToConnection_ATTPInscanNew';
     }
     axios({
         method: 'POST',
         'url': apiUrl.api_url_hubops + api,
         'data': this.input,
         headers: {
           'Authorization': "authkey xB84JJ89Hd25"
         }
       })
       .then(result => {
         if (result.data.ResultCode == 100) {
           this.$alert(result.data.ReturnMessage, "", "success");
           user_tracker.checkUserIP(this.userData[0], "AllocateHubToTouchPointForNetworkNew", this.$route.path , this.input);
           this.resetHubForm();
         } else {
           this.$alert(result.data.ReturnMessage, "", "error");
         }
         this.connDestLoading = false;
       }, error => {
         this.connDestLoading = false;
         console.error(error)
       })
   },

    jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
     var csvData = ''
     //Header
     if (this.title != null) {
       csvData += this.parseExtraData(this.title, '${data}\r\n')
     }
     //Fields
     for (let key in data[0]) {
       if (skipFilter.indexOf(key) == -1)
         csvData += csvfield[key] + ','
     }
     csvData = csvData.slice(0, csvData.length - 1)
     csvData += '\r\n'
     //Data
     data.map(function(item) {
       for (let key in item) {
         if (skipFilter.indexOf(key) == -1) {
           var escapedCSV = item[key] + '' // cast Numbers to string
           if (escapedCSV.match(/[,"\n]/)) {
             escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
           }
           if (escapedCSV == 'null')
             csvData += ',';
           else {
             if (dateFilder.indexOf(key) != -1)
               csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
             else
               csvData += escapedCSV + ','
           }
         }
       }
       csvData = csvData.slice(0, csvData.length - 1)
       csvData += '\r\n'
     })
     //Footer
     if (this.footer != null) {
       csvData += this.parseExtraData(this.footer, '${data}\r\n')
     }
     filename += moment().format('DD-MM-YYYY') + '.csv';
     return this.export(csvData, filename, "application/csv");
     return csvData
   },

    export (data, filename, mime) {
     let blob = this.base64ToBlob(data, mime)
     download(blob, filename, mime)
   },

    base64ToBlob(data, mime) {
     let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
     let bstr = atob(base64)
     let n = bstr.length
     let u8arr = new Uint8ClampedArray(n)
     while (n--) {
       u8arr[n] = bstr.charCodeAt(n)
     }
     return new Blob([u8arr], {
       type: mime
     })
   },

    exportDestinations() {
     this.connDestLoading = true;

     this.input = ({
       connectionid: this.ConnectionID.value,
       status      : 1,
       hubid       : 0,
       hubname     : '',
       hubzoneid   : 0,
       hubcityid   : 0,
       groupcityid : 0,
       groupids    : [],
       createdBy   : this.useremail,
       touchPointID: this.srcTouchPointName.value,
     })

     let api = '';
     if(this.currentTab=='outscan'){
       this.input.stoppointid = 0;
       api = 'getDestinationsByConnectionForAllocateToTuchPointNew';
     }else{
       api = 'getDestinationsByConnection_ATTPInscanNew';
     }
     axios({
         method: 'POST',
         'url': apiUrl.api_url_hubops + api,
         'data': this.input,
         'headers': {
           'authorization': 'authkey xB84JJ89Hd25',
         }
       })
       .then(result => {
         if (result.data.ResultCode == 100) {
           let expArr = result.data.ResponseData.map(i => ({ HubName:i.HubName +' ('+i.HubID+')', HubZoneName:i.HubZoneName, CityName:i.CityName, groupname:i.groupname }));

           this.csvFields = {
             'HubName': 'Hub Name',
             'HubZoneName': 'Hub Zone Name',
             'CityName': 'City Name',
             'groupname': 'Group Name'
           }

           this.jsonToCSV('DestinationByConnectionReport_', expArr, this.csvFields);
           this.$alertify.success(result.data.ReturnMessage)
         } else {
           this.$alertify.error(result.data.ReturnMessage)
         }
         this.connDestLoading = false;
       }, error => {
         this.connDestLoading = false;
         console.error(error)
       })
   },

    resetHubForm() {
     this.status = { value: "1", text: "Selected" },
     this.listDestHubNameData= [],
     this.destHubZone= '',
     this.destHubId= '',
     this.destCity= '',
     this.groupCity= '',
     this.destGroup= [],
     this.checkAllHub= false,
     this.connectionDestList= [],
     this.totalHubRows= 0,
     this.totaldestinationhubs= 0,
     this.totalmappedhubs= 0,
     this.allHubData= [],
     this.modelArr= [],
     this.checked= [],
     this.hubLoading= '',
     this.cityLoading= '',
     this.groupLoading= '',
     this.connDestLoading= false,
     this.$validator.reset('hub');
     this.getDestinationsByConnection();
   },

   resetHubSelection() {
    this.currentTab = 'inscan',
    this.tabs = [{
       key: 'inscan',
       value: 'Inscan',
       count: 0
     },
     {
       key: 'outscan',
       value: 'Outscan',
       count: 0
    }],
    this.status = { value: "1", text: "Selected" },
    this.listDestHubNameData= [],
    this.destHubZone= '',
    this.destHubId= '',
    this.destCity= '',
    this.groupCity= '',
    this.destGroup= [],
    this.checkAllHub= false,
    this.connectionDestList= [],
    this.totalHubRows= 0,
    this.totaldestinationhubs= 0,
    this.totalmappedhubs= 0,
    this.allHubData= [],
    this.modelArr= [],
    this.checked= [],
    this.hubLoading= '',
    this.cityLoading= '',
    this.groupLoading= '',
    this.connDestLoading= false,
    this.clickedMB= false,
    this.$validator.reset('hub');
  },

    takeAction() {
     this.mapMultipleHubsToConnection();
   },

   exportmappedinoutscandestinations() {
    if (!this.hubzoneid || Object.keys(this.routetype).length <= 0 || Object.keys(this.sourceHubId).length <= 0 || Object.keys(this.ConnectionID).length <= 0){
     document.getElementById("zone").innerHTML= (!this.hubzoneid) ? 'The Hub Zone field is required.':'';
     document.getElementById("route").innerHTML= (Object.keys(this.routetype).length <= 0) ? 'The Route Type field is required.':'';
     document.getElementById("source").innerHTML= (Object.keys(this.sourceHubId).length <= 0) ? 'The Source Hub Name field is required.':'';
     document.getElementById("conn").innerHTML= (Object.keys(this.ConnectionID).length <= 0) ? 'The Connection Name field is required.':'';
     return false;
    }
    document.getElementById("touch").innerHTML='';

    this.connDestLoading = true;

    this.input = ({
      connectionid: this.ConnectionID.value,
      createdBy   : this.useremail
    })

    axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'getInscanOutscanDestinations',
        'data': this.input,
        'headers': {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
      .then(result => {
        if (result.data.ReturnCode == 100) {

          let expArr = result.data.ResponseData.map(i => ({
            ConnectionName:     this.ConnectionID.text,
            SourceName:         this.sourceHubId.text,
            DestinationName:    this.TouchPointnameData[this.TouchPointnameData.length-1].text,
            touchpointhubname:  i.touchpointhubname.trim(),
            inscanhubname:      i.inscanhubname.trim(),
            outscanhubname:     i.outscanhubname.trim(),
            createddate:        i.createddate,
            createdby:          i.createdby,
            lastmodifieddate:   i.lastmodifieddate,
            lastmodifiedby:     i.lastmodifiedby,
          }));

          this.csvFields = {
            'ConnectionName':     'Connection Name',
            'SourceName':         'Origin',
            'DestinationName':    'Destination',
            'touchpointhubname':  'Touch Point Name',
            'inscanhubname':      'Inscan Destination Hub Name',
            'outscanhubname':     'Outscan Destination Hub Name',
            'createddate':        'Created Date',
            'createdby':          'Created By',
            'lastmodifieddate':   'Last Modified Date',
            'lastmodifiedby':     'Last Modified By'
          }

          this.jsonToCSV('MappedInscanOutscanDestinationReport_', expArr, this.csvFields);
          this.$alertify.success(result.data.ReturnMessage);
        } else {
          this.$alertify.error(result.data.ReturnMessage)
        }
        this.connDestLoading = false;
      }, error => {
        this.connDestLoading = false;
        console.error(error)
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/AllocateHubToTouchPointForNetworkNew/AllocateHubToTouchPointForNetworkNew.component.js